import { render, staticRenderFns } from "./NewSystem.vue?vue&type=template&id=5b27307b&scoped=true"
import script from "./NewSystem.vue?vue&type=script&lang=js"
export * from "./NewSystem.vue?vue&type=script&lang=js"
import style0 from "./NewSystem.vue?vue&type=style&index=0&id=5b27307b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27307b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b27307b')) {
      api.createRecord('5b27307b', component.options)
    } else {
      api.reload('5b27307b', component.options)
    }
    module.hot.accept("./NewSystem.vue?vue&type=template&id=5b27307b&scoped=true", function () {
      api.rerender('5b27307b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/NewSystem.vue"
export default component.exports